import { API_ROUTES } from '@/constants/apiRoutes';
import {
  ScheduledTransactionDetails,
  ScheduledTransactionListResponse,
  TransactionItem,
  TransactionListResponse,
} from '@/types/transactions';
import { api } from '@/utils/api';

export const getTransactionListService = async (
  uuid: string,
  queryParams: string,
) => {
  const { data } = await api<TransactionListResponse>({
    url: `${API_ROUTES.BANK_ACCOUNTS}${uuid}/${API_ROUTES.TRANSACTIONS}?${queryParams}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const getTransactionDetailsService = async (
  bankAccountId: string,
  transactionId: string,
) => {
  const { data } = await api<TransactionItem>({
    url: `${API_ROUTES.BANK_ACCOUNTS}${bankAccountId}/${API_ROUTES.TRANSACTIONS}${transactionId}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const getScheduledTransactionListService = async (
  uuid: string,
  queryParams: string,
) => {
  const { data } = await api<ScheduledTransactionListResponse>({
    url: `${API_ROUTES.BANK_ACCOUNTS}${uuid}/${API_ROUTES.SCHEDULED_TRANSACTIONS}?${queryParams}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const getScheduledTransactionDetailsService = async (
  transactionId: string,
) => {
  const { data } = await api<ScheduledTransactionDetails>({
    url: `${API_ROUTES.SCHEDULED_TRANSACTIONS}/${transactionId}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const cancelScheduledTransactionService = async (
  transactionId: string,
) => {
  const { data } = await api({
    url: `${API_ROUTES.SCHEDULED_TRANSACTIONS}/${transactionId}/cancel`,
    method: 'post',
    version: 2,
  });

  return data;
};
